import ReconnectingWebSocket from 'reconnecting-websocket'
// import store from '@/store/index'

const state = {
  ws: null
}

const mutations = {
  RESET (state) {
    if (state.ws) {
      state.ws.close()
    }
  },
  CONNECT (state) {
    mutations.RESET(state)
    state.ws = new ReconnectingWebSocket('wss://' + process.env.VUE_APP_HOST + process.env.BASE_URL + '/notify/work-update')
    state.ws.onmessage = (data) => {
      const notify = JSON.parse(data.data)
      // eslint-disable-next-line
      switch (notify.type) {
        case 'ADD':
        case 'UPDATE':
          // todo 避免整个刷新
          this.dispatch('work/getKanbanWorks', 0)
          break
      }
    }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
